// Mirrors the Happy Hour site's "Happy Hour" section.
.section {
    padding: 80px 0 64px;

    @media (min-width: 1024px) {
        padding: 96px 0 80px;
    }
}

// When the hero above has no button there is less to clear.
.compactTop {
    padding-top: 56px;

    @media (min-width: 1024px) {
        padding-top: 80px;
    }
}

.hours {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
    margin: 12px 0 0;
    text-transform: uppercase;

    @media (min-width: 1024px) {
        font-size: 30px;
        margin-top: 16px;
    }
}

.hoursLine {
    display: block;
}

.offers {
    display: grid;
    gap: 24px;
    margin-top: 32px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1024px) {
        margin-top: 40px;
    }
}

.offer {
    background-color: var(--hh-card);
}

.offerPhoto {
    aspect-ratio: 7 / 5;
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
}

.offerBody {
    padding: 28px 24px 40px;
}

.offerTitle {
    color: var(--hh-lobster);
    font-family: var(--hh-font-body);
    font-size: 30px;
    font-weight: 700;
    letter-spacing: normal;
    line-height: 1;
    margin: 0;
    text-transform: uppercase;
    text-wrap: balance;

    @media (min-width: 1024px) {
        font-size: 36px;
    }
}

.offerList {
    font-size: 15px;
    list-style: none;
    margin: 24px 0 0;
    padding: 0;

    & li + li {
        margin-top: 8px;
    }

    @media (min-width: 1024px) {
        font-size: 16px;
    }
}

.feature {
    display: grid;
    margin-top: 32px;
    overflow: hidden;

    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
    }

    @media (min-width: 1024px) {
        margin-top: 40px;
    }
}

.featurePhoto {
    aspect-ratio: 600 / 520;
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.featurePanel {
    align-items: center;
    background-color: var(--hh-panel);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 32px;
    text-align: center;

    @media (min-width: 1024px) {
        padding: 40px 48px;
    }
}

.featureScript {
    color: var(--hh-lobster);
    font-size: 34px;

    @media (min-width: 1024px) {
        font-size: 44px;
    }
}

// The deeper red keeps 4.5:1 on the panel colour.
.featureEyebrow {
    color: var(--hh-lobster-deep);
    font-size: 16px;
    letter-spacing: 0.04em;
    margin: 8px 0 0;
    text-transform: uppercase;

    @media (min-width: 1024px) {
        font-size: 20px;
    }
}

.featureRule {
    border-top: 1px solid rgb(0 0 0 / 70%);
    margin-top: 20px;
    max-width: 24rem;
    width: 80%;
}

.featureTitle {
    font-family: var(--hh-font-body);
    font-size: 26px;
    font-weight: 700;
    letter-spacing: normal;
    margin: 20px 0 0;
    text-transform: uppercase;

    @media (min-width: 1024px) {
        font-size: 32px;
    }
}

.featureBody {
    font-size: 18px;
    line-height: 1.375;
    margin: 12px 0 0;
    max-width: 24rem;

    @media (min-width: 1024px) {
        font-size: 21px;
    }
}

.legal {
    font-size: 14px;
    line-height: 1.625;
    margin: 24px auto 0;
    max-width: 64rem;
    text-wrap: balance;

    & p {
        margin: 0;
    }

    & a {
        color: inherit;
        text-decoration: underline;
        text-underline-offset: 2px;

        &:hover {
            color: var(--hh-lobster);
        }
    }

    @media (min-width: 1024px) {
        font-size: 15px;
        margin-top: 32px;
    }
}
